import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { phoneNumberService, PhoneNumber as PhoneNumberType } from '../services/phoneNumberService';

const VVIPContainer = styled.div`
  margin-top: 50px;
  min-height: calc(100vh - 70px);

  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 25% 25%, rgba(255, 215, 0, 0.1) 0%, transparent 40%),
      radial-gradient(circle at 75% 75%, rgba(255, 165, 0, 0.08) 0%, transparent 40%),
      radial-gradient(circle at 50% 10%, rgba(255, 215, 0, 0.05) 0%, transparent 50%);
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      repeating-linear-gradient(
        45deg,
        transparent,
        transparent 35px,
        rgba(255, 215, 0, 0.02) 35px,
        rgba(255, 215, 0, 0.02) 70px
      );
    z-index: 0;
  }
`;

const ImageSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
  padding: 20px 8px 0;
  position: relative;
  z-index: 2;
  @media (max-width: 768px) {
    padding: 10px 4px 0;
    margin-bottom: 0;
  }
`;

const ImageCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 96%;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  @media (max-width: 768px) {
    max-width: 98%;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const ProcessImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 400px;
  display: block;
  object-fit: contain;
  transition: transform 0.3s ease;
  @media (max-width: 768px) {
    height: 400px;
    max-height: 400px;
  }
`;

const ImageTitle = styled.div`
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  color: white;
  padding: 24px 32px;
  text-align: center;
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 20px 24px;
  }
`;

const HeroBanner = styled.section`
  height: 300px;
  background: linear-gradient(135deg, #6366f1, #4f46e5, #374151);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      linear-gradient(45deg, transparent 30%, rgba(220, 38, 38, 0.2) 30%, rgba(220, 38, 38, 0.2) 33%, transparent 33%),
      linear-gradient(-45deg, transparent 67%, rgba(59, 130, 246, 0.2) 67%, rgba(59, 130, 246, 0.2) 70%, transparent 70%);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
`;

const HeroTitle = styled.h1`
  font-size: 4.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
  letter-spacing: 8px;

  @media (max-width: 768px) {
    font-size: 3rem;
    letter-spacing: 4px;
  }

  @media (max-width: 480px) {
    font-size: 2.5rem;
    letter-spacing: 2px;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.5rem;
  font-weight: 300;
  opacity: 0.9;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 1.2rem;
    letter-spacing: 1px;
  }
`;

const VIPBadge = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  background: linear-gradient(135deg, #dc2626, #b91c1c);
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 1px;
  z-index: 2;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);

  &::before {
    content: '★';
    margin-right: 8px;
    color: #fbbf24;
  }
`;

const LuxuryIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  padding: 12px;
  border-radius: 50%;
  font-size: 1.5rem;
  z-index: 2;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);

  &::before {
    content: '✈';
  }
`;

const TopSection = styled.div`
  background: white;
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
`;

const SearchRow = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;


const SearchInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }
`;

const SearchButton = styled.button`
  background: linear-gradient(135deg, #1f2937, #374151);
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #374151, #4b5563);
    transform: translateY(-1px);
  }
`;

const SortRow = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  margin-top: 15px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 10px;
  }
`;

const SortSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  background: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #6366f1;
  }
`;

const Breadcrumb = styled.div`
  color: #6b7280;
  font-size: 14px;
  margin-left: auto;
`;

const MainLayout = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 10px 20px 40px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 0 8px 5px;
  }
`;

const Sidebar = styled.div`
  width: 280px;
  background: white;
  border-radius: 12px;
  padding: 20px;
  height: fit-content;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const FilterSection = styled.div`
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  cursor: pointer;
  padding: 5px 0;
`;

const FilterTitle = styled.h3`
  color: #374151;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

const FilterInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 10px;

  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
  }
`;

const PriceRow = styled.div`
  display: flex;
  gap: 10px;
`;

const PriceInput = styled.input`
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
  }
`;

const FilterButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  color: white;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 10px;

  &:hover {
    background: linear-gradient(135deg, #4f46e5, #4338ca);
  }
`;

const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CategoryItem = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  cursor: pointer;
  font-size: 14px;
  color: #374151;

  &:hover {
    color: #6366f1;
  }
`;

const CategoryCheckbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 10px;
  accent-color: #6366f1;
`;

const CategoryCount = styled.span`
  color: #6b7280;
  font-size: 12px;
`;

const ContentArea = styled.div`
  flex: 1;
`;

const NumbersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    gap: 10px;
    grid-template-columns: 1fr;
  }
`;

const NumberCard = styled.div`
  background: linear-gradient(135deg, #1a1a1a, #0d0d0d);
  border: 3px solid;
  border-image: linear-gradient(135deg, #FFD700, #FFA500, #FFD700) 1;
  border-radius: 15px;
  padding: 30px 25px;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 0 6px 25px rgba(255, 215, 0, 0.2);
  overflow: visible;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 20px 15px;
    min-height: 180px;
    border-width: 2px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    border: 1px solid rgba(255, 215, 0, 0.3);
    border-radius: 10px;
    z-index: 1;
  }

  &::after {
    content: 'VVIP';
    position: absolute;
    top: 15px;
    right: 15px;
    background: linear-gradient(135deg, #FFD700, #FFA500);
    color: #000000;
    padding: 3px 15px;
    border-radius: 12px;
    font-size: 0.7rem;
    font-weight: 900;
    letter-spacing: 1px;
    z-index: 4;
    text-shadow: none;
    box-shadow: 0 3px 10px rgba(255, 215, 0, 0.4);
    border: 1px solid #000000;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 35px rgba(255, 215, 0, 0.3);
    border-image: linear-gradient(135deg, #FFA500, #FFD700, #FFA500) 1;
  }
`;

const PriceTag = styled.div`
  color: #FFD700;
  font-size: 1.8rem;
  font-weight: 800;
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
  position: relative;
  z-index: 2;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const PhoneNumber = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: #FFD700 !important;
  margin-top: 25px;
  margin-bottom: 15px;
  text-align: center;
  letter-spacing: 1.5px;
  text-shadow: 0 0 15px rgba(255, 215, 0, 0.6);
  position: relative;
  z-index: 2;
  white-space: nowrap;
  min-height: 30px;

  .highlight {
    color: #FFA500;
    text-shadow: 0 0 20px rgba(255, 165, 0, 0.8);
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
    letter-spacing: 1px;
  }
`;

const SumTotal = styled.div`
  color: rgba(255, 215, 0, 0.9) !important;
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 600;
  text-align: center;
  position: relative;
  z-index: 2;
  letter-spacing: 0.5px;
  min-height: 20px;

  strong {
    font-weight: 700;
    color: rgba(255, 215, 0, 0.9) !important;
  }
  text-shadow: 0 0 8px rgba(255, 215, 0, 0.3);
`;

const CrownIcon = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 1.8rem;
  z-index: 4;
  filter: drop-shadow(0 0 12px rgba(255, 215, 0, 0.8));

  &::before {
    content: '👑';
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
`;

const ActionButton = styled.button<{ $primary?: boolean }>`
  padding: 12px 28px;
  border: 2px solid #FFD700;
  border-radius: 25px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  position: relative;
  z-index: 2;

  ${props => props.$primary ? `
    background: linear-gradient(135deg, #FFD700, #FFA500);
    color: #000000;
    border-color: #FFD700;
    box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    &:hover {
      background: linear-gradient(135deg, #FFA500, #FFD700);
      border-color: #FFA500;
      transform: translateY(-2px) scale(1.05);
      box-shadow: 0 6px 20px rgba(255, 215, 0, 0.4);
    }
  ` : `
    background: transparent;
    color: #FFD700;

    &:hover {
      background: rgba(255, 215, 0, 0.1);
    }
  `}
`;


const VipBadge = styled.div`
  position: absolute;
  top: -10px;
  left: 15px;
  background: linear-gradient(135deg, #FFD700, #FFC700);
  color: #000000;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 900;
  z-index: 4;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
  letter-spacing: 1px;
`;

// Function to calculate sum total of digits in a phone number
const calculateSumTotal = (phoneNumber?: string): React.ReactNode => {
  if (!phoneNumber) return <><strong>-</strong></>;

  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, '');

  // Calculate sum of all digits (first sum)
  const firstSum = digits.split('').reduce((acc, digit) => acc + parseInt(digit, 10), 0);

  // Calculate sum of the first sum (second sum)
  const secondSum = firstSum.toString().split('').reduce((acc, digit) => acc + parseInt(digit, 10), 0);

  // Calculate sum of the second sum (third sum)
  const thirdSum = secondSum.toString().split('').reduce((acc, digit) => acc + parseInt(digit, 10), 0);

  // Return format: "firstSum-secondSum-thirdSum" with bold formatting
  return <><strong>{firstSum}-{secondSum}-{thirdSum}</strong></>;
};

const VVIPCollection: React.FC = () => {
  const [vvipNumbers, setVvipNumbers] = useState<PhoneNumberType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadVVIPNumbers();
  }, []);

  const loadVVIPNumbers = async () => {
    setLoading(true);
    try {
      const numbers = await phoneNumberService.getVVIPNumbers();
      setVvipNumbers(numbers);
    } catch (error) {
      console.error('Error loading VVIP numbers:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (number?: string) => {
    return number || '';
  };

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
    }).format(price);
  };


  return (
    <VVIPContainer>
      <ImageSection>
        <ImageCard>
          <ImageWrapper>
            <ProcessImage
              src="/vvip.jpg"
              alt="How It Works Banner"
              loading="eager"
              decoding="async"
            />
          </ImageWrapper>
        </ImageCard>
      </ImageSection>


      <MainLayout>
        <ContentArea>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#FFD700' }}>
              Loading VVIP Numbers...
            </div>
          ) : vvipNumbers.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#FFD700' }}>
              No VVIP numbers available at the moment.
            </div>
          ) : (
            <NumbersGrid>
              {vvipNumbers.map((item) => (
                <NumberCard key={item.id}>
                  <CrownIcon />
                  <PhoneNumber style={{ color: '#FFD700', fontSize: '1.8rem', fontWeight: 700 }}>
                    {item.number || 'No number'}
                  </PhoneNumber>
                  <SumTotal style={{ color: '#FFD700', fontSize: '16px' }}>
                    Sum Total: {calculateSumTotal(item.number)}
                  </SumTotal>
                  <PriceTag>{formatPrice(item.price)}</PriceTag>
                  <ButtonRow>
                    <ActionButton
                      $primary
                      onClick={() =>
                        window.open(
                          `https://wa.me/917700071600?text=I'm interested in ${item.number}`,
                          '_blank'
                        )
                      }
                    >
                      Buy Now
                    </ActionButton>
                  </ButtonRow>
                </NumberCard>
              ))}
            </NumbersGrid>
          )}
        </ContentArea>
      </MainLayout>
    </VVIPContainer>
  );
};

export default VVIPCollection;